export const REGISTRATION_STEPS = {
    REGISTRATION: "registration",
    PAYMENT: "payment",
    SUCCESS: "success"
} as const;

export type RegistrationStep =
    (typeof REGISTRATION_STEPS)[keyof typeof REGISTRATION_STEPS];